import { render, staticRenderFns } from "./subcategory.vue?vue&type=template&id=5049baf1&"
import script from "./subcategory.vue?vue&type=script&lang=js&"
export * from "./subcategory.vue?vue&type=script&lang=js&"
import style0 from "./subcategory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports